import * as React from "react";
import SliderSwiper from "~/components/swiper/slider-swiper";
import { breakpoints } from "~/utils/breakpoint-utils";
import { Settings } from "react-slick";
import ArrowLink from "../arrow-link/arrow-link";
import { IAuthor } from "~/types/author";
import AuthorTile from "../author-tile/author-tile";
import classNames from "classnames";
import ContentSection from "../content-section/content-section";

export interface AuthorSliderProps {
    title?: string;
    viewMoreLink?: string;
    authors: IAuthor[];
    authorCtaLinkText: string;
    enableThemeBackground?: boolean;
    anchorId?: string;
}

const AuthorSlider: React.SFC<AuthorSliderProps> = ({
    title,
    viewMoreLink,
    authors,
    authorCtaLinkText,
    enableThemeBackground,
    ...props
}) => {
    const headerTitle = title && (
        <h2 className="author-slider__title" dangerouslySetInnerHTML={{ __html: title }} />
    );
    const headerLink = viewMoreLink && <ArrowLink className="author-slider__link" link={viewMoreLink} />;

    const swiperSettings: Settings = {
        slidesToShow: 5.3,
        swipeToSlide: true,
        lazyLoad: "ondemand",
        initialSlide: 0,
        responsive: [
            {
                breakpoint: breakpoints.rat,
                settings: {
                    slidesToShow: 1.2
                }
            },
            {
                breakpoint: breakpoints.rabbit,
                settings: {
                    slidesToShow: 1.5
                }
            },
            {
                breakpoint: breakpoints.dog,
                settings: {
                    slidesToShow: 2.3
                }
            },
            {
                breakpoint: breakpoints.wolf,
                settings: {
                    slidesToShow: 3.3
                }
            },
            {
                breakpoint: breakpoints.lion,
                settings: {
                    slidesToShow: 4.3
                }
            }
        ]
    };

    const baseClass = "author-slider";
    const componentClasses = classNames(baseClass, {
        [`${baseClass}--theme-background`]: enableThemeBackground
    });

    return (
        <ContentSection className={componentClasses} {...props}>
            {(headerTitle || headerLink) && (
                <div className={`${baseClass}__header`}>
                    {headerTitle}
                    {headerLink}
                </div>
            )}
            {authors.length > 0 && (
                <SliderSwiper settings={swiperSettings}>
                    {authors.map((author, index) => (
                        <AuthorTile {...author} authorCtaLinkText={authorCtaLinkText} key={index} />
                    ))}
                </SliderSwiper>
            )}
        </ContentSection>
    );
};

export default AuthorSlider;
